// extracted by mini-css-extract-plugin
export default {"container":"UtilitySetMinimal_container__kgCGZ","button":"UtilitySetMinimal_button__MUyDe","darkmode":"UtilitySetMinimal_darkmode__6CaEQ"};